import React, { useEffect, useState } from 'react'
import { InputText } from 'primereact/inputtext';
import ProCalendar from '../../components/common/ProCalendar';
import "../../pages/DashBoard.css"
import ProTreeTable from '../../components/common/ProTreeTable';
import { Panel } from 'primereact/panel';

import ProCensusFilter from '../../components/census/ProCensusFilter';
import { Sidebar } from 'primereact/sidebar';
import { capitalizeFirstLetter } from '../../constants/ProConstants';
import ProCensusForm from '../../components/census/ProCensusForm';
import useCensus from '../../hooks/useCensus';
import "../../components/census/census.css"
import { GetStartOfDay, FormatDateFromString, GetISODate, FormattedDateString } from '../../utilities/DateHelper';
import { useLocationServices } from '../../hooks/useLocationServices';
import _ from 'lodash'
import useFormModelServices from '../../hooks/useFormModelServices';
import ProViewBedDetailsForm from '../../components/census/ProViewBedDetailsForm';
import { Confirm } from "../../utilities/ProDialogs";
import { GetClientOrDependentName } from '../../utilities/Helper';
import  useTreeTemplateServices  from '../../hooks/useTreeTemplateServices';
import {useHierarchyService} from '../../hooks/useHierarchyService';
import ProBedHistory from '../../components/census/ProBedHistory';
import ProClientHistory from '../../components/census/ProClientHistory';
import ProMultiSelect from '../../components/common/ProMultiSelect';
import NotFound from "../general/NotFound";


const Census = () => {  
   
    const [showFilter, setShowFilter] = useState(false);   
    const [toggleSideBar, setToggleSideBar] = useState(false);   
    const [formAction, setFormAction] = useState("");
    const [formModel, setFormModel] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [formHeader, setFormHeader] = useState("");
    const [formOrientation, setFormOrientation] = useState('right')

    const { data:{tree, selectedTreeNode},actions:{ParseHierarchy}} =  useHierarchyService()
    const { locations, isLocationsInitialized, primaryLocationId } = useLocationServices();
    const { GetCensusModel, GetDetails } = useFormModelServices();
    const { data:{ filter, isFilterApplied, selectedLocations, defaultExpandedKeys }, 
            actions:{InitializeDefaults, SetSelectedLocations, SetSelectedDate, RemoveAssignOrReserve } } = useCensus({ refreshTree: true });
   
    useEffect(() => {       
        if (_.get(locations, "length") > 0) {
            if(selectedLocations.length === 0){                
                InitializeDefaults(GetISODate(GetStartOfDay()), [_.find(locations, l=>_.isEqual(l.id, primaryLocationId)) || locations[0]])   
            }       
           
        }
    }, [InitializeDefaults, selectedLocations, locations, primaryLocationId])

    useEffect(()=>{
        setToggleSideBar(false);
    }, [selectedTreeNode])

   const performAction = async (node, assignmentData, action, formTitle, orientation ='right') => { 
        setToggleSideBar(false); 
        ParseHierarchy();
        setFormOrientation(orientation)      
        let data =  _.includes(["VIEW_BED", "BED_HISTORY", "CLIENT_HISTORY"], action)?await GetDetails(node, filter.date, assignmentData, action) : await GetCensusModel(assignmentData);
       
        switch(action){
            case "ASSIGN":
            case "RESERVE":
            case "VIEW_BED":
            case "MOVE": 
            case "EDIT_ASSIGN":
            case "BED_HISTORY":
            case "CLIENT_HISTORY":
                setFormModel(data);
                setFormHeader(`${capitalizeFirstLetter(formTitle)}`)
                setFormAction(action);
                setToggleSideBar(true);
                break;  
            case "REMOVE_ASSIGN":
            case "REMOVE_RESERVE":
                data = {...data, date:FormattedDateString(filter.date), action:"CANCEL"}                
                Confirm(async () => { await  RemoveAssignOrReserve(data);},
                () => { console.log("Remove not confirmed"); },
                _.isEqual(action, "REMOVE_RESERVE")?`Cancel reservation for ${GetClientOrDependentName(data)} from ${FormatDateFromString(data.startDate)} to ${FormatDateFromString(data.endDate)} for ${node.data.name}?\nAny reservation for dependents must be removed seperately.`
                :`Remove bed assignment for ${GetClientOrDependentName(data)} from ${FormatDateFromString(data.startDate)} to ${FormatDateFromString(data.endDate)} for ${node.data.name}?\nBed assignments for dependents must be removed separately.`)               
                break;              
            default:
            break;
        }
       
    }
    const toggleFilter = () => {
        setShowFilter(prev => !prev)
    }

    const onDateChanged = (e) => {
        var formattedDate = GetISODate(e.value)      
        SetSelectedDate(formattedDate)
    }
    const {data:{CensusTableConfig}, actions :{OnTreeNodeSelect}} = useTreeTemplateServices({performAction}); 

    // if(isLocationsInitialized && _.get(locations, "length") === 0)
    //     return <NotFound/>

    return (<div>
        <div className='header-row'>           
            <div className="search-box">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText className='search-bar-input' onChange={(e) => setSearchValue(e.target.value)} placeholder="Search" />
                </span>
            </div>
            <div>
                <ProMultiSelect value={selectedLocations} options={locations} onChange={SetSelectedLocations}/>
            </div>
            <div className='header-filter-box' onClick={() => setShowFilter(prev => !prev)}>
                <span style={{ marginRight: "5px" }}> Filter</span>
                {isFilterApplied && <i className="fa fa-filter margin-top-4"></i>}
                {!isFilterApplied && <i className="fal fa-filter margin-top-4"></i>}
            </div>
            <div className='census-calendar' >
                <ProCalendar id="censusDate"
                    placeholder="Date"
                    value={filter.date}
                    onChange={onDateChanged}
                    style={{ width: "100%", marginBottom: "2px", height: "40px" }}                    
                    required />
            </div>
        </div>
        {showFilter && <div className="p-col-16 p-lg-12">
            <Panel header="Filter Options">
                <ProCensusFilter toggleFilter={toggleFilter} />
            </Panel>
        </div>}
        <div>
           {_.isEqual(formOrientation, 'right') && <Sidebar dismissable={false} modal={false}
                visible={toggleSideBar} position={formOrientation}
                style={_.isEqual(formOrientation, 'right')?{ width: '30em' }:{minHeight: '20em'}} onHide={() => setToggleSideBar(false)} icons={() => (
                    <h6 className="p-sidebar-close"
                        style={{ fontWeight: '700', fontSize: '20px', width: '100%', margin: 'auto' }}>{formHeader}</h6>
                )}>               
               {(!_.includes(["VIEW_BED", "BED_HISTORY", "CLIENT_HISTORY"], formAction)) && <ProCensusForm formModel={formModel} formAction={formAction} closeSideBar={(e) => setToggleSideBar(false)} />}
               {_.isEqual(formAction, "VIEW_BED") && <ProViewBedDetailsForm formModel={formModel}  closeSideBar={(e) => setToggleSideBar(false)} />}               
            </Sidebar>}
           {_.isEqual(formOrientation, 'bottom') && <Sidebar dismissable={false} modal={false}
                visible={toggleSideBar} position={formOrientation}
                style={_.isEqual(formOrientation, 'right')?{ width: '30em' }:{minHeight: '20em'}} onHide={() => setToggleSideBar(false)} icons={() => (
                    <h6 className="p-sidebar-close"
                        style={{ fontWeight: '700', fontSize: '20px', width: '100%', margin: 'auto' }}>{formHeader}</h6>
                )}>               
              
               {_.isEqual(formAction, "BED_HISTORY") && <ProBedHistory formModel = {formModel}  closeSideBar={(e) => setToggleSideBar(false)} />}
               {_.isEqual(formAction, "CLIENT_HISTORY") && <ProClientHistory formModel = {formModel}  closeSideBar={(e) => setToggleSideBar(false)} />}
            </Sidebar>}
        </div>
        <div>
            <div className='data-row'>                
                <div className="p-col-16 p-lg-12">
                    {(tree && tree.length > 0) && <ProTreeTable treeData={tree} defaultSelectionKey={tree[0].key} defaultExpandedKeys={defaultExpandedKeys} isFilterApplied={isFilterApplied} searchValue={searchValue} config={CensusTableConfig} OnTreeNodeSelect={OnTreeNodeSelect}  />}

                    {(isLocationsInitialized && _.get(locations, "length") === 0) && <div>No Records found</div>}
                </div>
            </div>
        </div>       
    </div>

    )
}

export default Census;